import { SlideOverContentWrapper } from '@/components/slideOvers_v2/SlideOverContentWrapper';
import { SlideOverHeader } from '@/components/slideOvers_v2/SlideOverHeader';
import { SlideOverWrapper } from '@/components/slideOvers_v2/SlideOverWrapper';
import {
  EmailTemplatePreview,
  type EmailTemplateFormData,
} from '@/features/campaigns/components/CreateCampaign_v2/steps/Email/TemplatePreview/EmailTemplatePreview';
import { TemplatePreview } from '@/features/campaigns/components/CreateCampaign_v2/steps/Whatsapp/TemplatePreview/TemplatePreview';
import { SmsTemplatePreview } from '@/features/campaigns/components/CreateCampaign_v2/steps/Sms/TemplatePreview/SmsTemplatePreview';
import { ISlideOverContentProps } from '@/models/slideOver';
import { FC, PropsWithChildren } from 'react';
import { ComuniChannel } from '../../templates/catalog';
import { stripTopicPrefix } from '../../templates/topicPrefix';

export type ModelloPreviewData = {
  channel: ComuniChannel;
  name: string;
  formData: Record<string, unknown>;
};

type ModelloPreviewSlideOverProps = PropsWithChildren<ISlideOverContentProps & { model: ModelloPreviewData }>;

export const ModelloPreviewSlideOver: FC<ModelloPreviewSlideOverProps> = ({ model }) => {
  return (
    <SlideOverWrapper>
      <SlideOverHeader title={stripTopicPrefix(model.name)} className='md:p-4' />
      <SlideOverContentWrapper>
        <div className='flex justify-center pb-8'>
          {model.channel === 'whatsapp' && <TemplatePreview formData={model.formData as Parameters<typeof TemplatePreview>[0]['formData']} />}
          {model.channel === 'sms' && <SmsTemplatePreview variant='sheet' formData={model.formData} />}
          {model.channel === 'email' && <EmailTemplatePreview formData={model.formData as EmailTemplateFormData} />}
        </div>
      </SlideOverContentWrapper>
    </SlideOverWrapper>
  );
};
